/* eslint-disable no-undef */
import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview'
import store from '@src/store'

Vue.use(Router)

const routes = [
  {
    path: '',
    name: 'index',
    component: resolve => require(['@biz/index.vue'], resolve)
  },
  {
    path: '/home',
    component: resolve => require(['@biz/home.vue'], resolve),
    name: 'home',
    children: [
      {
        path: '/home/analysis',
        name: 'analysis',
        redirect: '/home/analysis/org',
        component: resolve => require(['@biz/analysis/index.vue'], resolve),
        children: [
          {
            path: '/home/analysis/homework',
            name: 'homework',
            component: resolve =>
              require(['@biz/analysis/homework.vue'], resolve)
          },
          {
            path: '/home/analysis/org',
            name: 'org',
            component: resolve => require(['@biz/analysis/org.vue'], resolve)
          },
          {
            path: '/home/analysis/student',
            name: 'studentData',
            component: resolve =>
              require(['@biz/analysis/student.vue'], resolve)
          },
          {
            path: '/home/analysis/teacher',
            name: 'teacherData',
            component: resolve =>
              require(['@biz/analysis/teacher.vue'], resolve)
          },
          {
            path: '/home/analysis/activity',
            name: 'activityData',
            component: resolve =>
              require(['@biz/analysis/activity.vue'], resolve)
          }
        ]
      },
      {
        path: '/home/brand',
        name: 'brand',
        redirect: '/home/brand/info',
        component: resolve => require(['@biz/brand/index.vue'], resolve),
        children: [
          {
            path: '/home/brand/banner',
            name: 'orgBanner',
            component: resolve => require(['@biz/brand/banner.vue'], resolve)
          },
          {
            path: '/home/brand/info',
            name: 'orgInfo',
            component: resolve => require(['@biz/brand/info.vue'], resolve)
          },
          {
            path: '/home/brand/preview',
            name: 'preview',
            component: resolve => require(['@biz/brand/preview.vue'], resolve)
          }
        ]
      },
      {
        path: '/home/content',
        name: 'content',
        redirect: '/home/content/item',
        component: resolve => require(['@biz/content/index.vue'], resolve),
        children: [
          {
            path: '/home/content/item',
            name: 'itemUpload',
            component: resolve => require(['@biz/content/item.vue'], resolve)
          }
        ]
      },
      {
        path: '/home/admin',
        name: 'admin',
        redirect: '/home/admin/index',
        component: resolve => require(['@biz/admin/index.vue'], resolve),
        children: [
          {
            path: '/home/admin/index',
            name: 'adminManage',
            component: resolve => require(['@biz/admin/index.vue'], resolve)
          }
        ]
      },
      {
        path: '/home/school',
        name: 'school',
        redirect: '/home/school/teacher',
        component: resolve => require(['@biz/school/index.vue'], resolve),
        children: [
          {
            path: '/home/school/class',
            name: 'class',
            component: resolve => require(['@biz/school/class.vue'], resolve)
          },
          {
            path: '/home/school/manager',
            name: 'manager',
            component: resolve => require(['@biz/school/manager.vue'], resolve)
          },
          {
            path: '/home/school/studentAccount',
            name: 'studentAccount',
            component: resolve => require(['@biz/school/studentNum.vue'], resolve)
          },
          {
            path: '/home/school/student',
            name: 'student',
            component: resolve => require(['@biz/school/student.vue'], resolve)
          },
          {
            path: '/home/school/experienceClass',
            name: 'experienceClass',
            component: resolve => require(['@biz/school/experienceClass.vue'], resolve)
          },
          {
            path: '/home/school/studentApply',
            name: 'studentApply',
            component: resolve => require(['@biz/school/studentApply.vue'], resolve)
          },
          {
            path: '/home/school/teacher',
            name: 'teacher',
            component: resolve => require(['@biz/school/teacher.vue'], resolve)
          }
        ]
      },
      {
        path: '/home/evaluation',
        name: 'evaluation',
        redirect: '/home/evaluation/list',
        component: resolve => require(['@biz/evaluation/index.vue'], resolve),
        children: [
          {
            path: '/home/evaluation/list',
            name: 'evaluationList',
            component: resolve => require(['@biz/evaluation/list.vue'], resolve)
          },
          {
            path: '/home/evaluation/edit',
            name: 'evaluationEdit',
            component: resolve => require(['@biz/evaluation/edit.vue'], resolve)
          },
          {
            path: '/home/evaluation/report',
            name: 'evaluationReport',
            component: resolve => require(['@biz/evaluation/report.vue'], resolve)
          }
        ]
      },
      {
        path: '/home/test',
        name: 'Test',
        redirect: '/home/test/videoDemo',
        component: resolve => require(['@biz/test/videoDemo.vue'], resolve),
        children: [
          {
            path: '/home/test/videoDemo',
            name: 'videoDemo',
            component: resolve => require(['@biz/test/videoDemo.vue'], resolve)
          }
        ]
      }
    ]
  }
  // {
  //   path: '/home/brand/preview/:type',
  //   name: 'orgPreview',
  //   component: resolve => require(['@biz/brand/preview.vue'], resolve)
  // }
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach(({ path }, from, next) => {
  iView.LoadingBar.start()
  if (!store.getters.isLogin && path !== '/') {
    next({
      path: '/'
    })
  } else if (store.getters.isLogin && path === '/') {
    next({
      path: '/home'
    })
  } else {
    next()
  }
})

router.afterEach(() => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
